/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Externaldepartmentuniversity2Inputs */

const en__field_externaldepartmentuniversity2 = /** @type {(inputs: _Field_Externaldepartmentuniversity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External: University`)
};

const de__field_externaldepartmentuniversity2 = /** @type {(inputs: _Field_Externaldepartmentuniversity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern: Universität`)
};

/**
* | output |
* | --- |
* | "External: University" |
*
* @param {_Field_Externaldepartmentuniversity2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_externaldepartmentuniversity2 = /** @type {((inputs?: _Field_Externaldepartmentuniversity2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Externaldepartmentuniversity2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_externaldepartmentuniversity2(inputs)
	return de__field_externaldepartmentuniversity2(inputs)
});
export { _field_externaldepartmentuniversity2 as "_field_externalDepartmentUniversity" }